import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const BUYERS = [{
  name: 'María',
  city: 'Miami, FL'
}, {
  name: 'Elena',
  city: 'Los Angeles, CA'
}, {
  name: 'Lucía',
  city: 'Houston, TX'
}, {
  name: 'Carla',
  city: 'New York, NY'
}, {
  name: 'Ana',
  city: 'Chicago, IL'
}, {
  name: 'Sofía',
  city: 'Dallas, TX'
}, {
  name: 'Valentina',
  city: 'San Antonio, TX'
}, {
  name: 'Camila',
  city: 'Phoenix, AZ'
}, {
  name: 'Laura',
  city: 'Las Vegas, NV'
}, {
  name: 'Andrea',
  city: 'Orlando, FL'
}, {
  name: 'Daniela',
  city: 'San Diego, CA'
}, {
  name: 'Paula',
  city: 'Denver, CO'
}, {
  name: 'Gabriela',
  city: 'Austin, TX'
}, {
  name: 'Isabel',
  city: 'Tampa, FL'
}, {
  name: 'Marcos',
  city: 'San Jose, CA'
}];
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/j8KJtRuKUfgjqwyKWN9igV/Imagen.Hero.png';
const PRODUCT_NAME = 'El Fin de las Rabietas';
const PRODUCT_PRICE = '$6.39';
function getRandomBuyer(lastIndex: number): {
  buyer: (typeof BUYERS)[0];
  index: number;
} {
  let index = lastIndex;
  while (index === lastIndex) {
    index = Math.floor(Math.random() * BUYERS.length);
  }
  return {
    buyer: BUYERS[index],
    index
  };
}
function timeAgo(): string {
  const mins = Math.floor(Math.random() * 12) + 1;
  return `hace ${mins} min`;
}
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(BUYERS[0]);
  const [time, setTime] = useState('hace 2 min');
  const [lastIndex, setLastIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const showNext = useCallback(() => {
    const {
      buyer: newBuyer,
      index
    } = getRandomBuyer(lastIndex);
    setBuyer(newBuyer);
    setTime(timeAgo());
    setLastIndex(index);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 3000);
  }, [lastIndex]);
  useEffect(() => {
    if (!isMobile) return;
    const initialDelay = setTimeout(() => {
      showNext();
    }, 4000);
    const interval = setInterval(() => {
      showNext();
    }, 7000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [isMobile, showNext]);
  if (!isMobile) return null;
  return <div className="fixed bottom-6 left-4 right-4 z-50 pointer-events-none" data-id="element-2">
      <AnimatePresence data-id="element-3">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 60,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300,
        mass: 0.8
      }} className="pointer-events-auto mx-auto max-w-[380px]" data-id="element-4">
            <div className="flex items-center gap-3 px-4 py-3 rounded-2xl border border-white/30" style={{
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(20px) saturate(180%)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06)'
        }} data-id="element-5">
              {/* Product Image */}
              <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 bg-gray-100" data-id="element-6">
                <img src={PRODUCT_IMAGE} alt={PRODUCT_NAME} className="w-full h-full object-cover" data-id="element-7" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-8">
                <div className="flex items-center justify-between gap-2" data-id="element-9">
                  <span className="text-xs text-gray-400 font-medium tracking-wide uppercase" data-id="element-10">
                    Compra verificada
                  </span>
                  <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-11">
                    {time}
                  </span>
                </div>
                <p className="text-[14px] leading-snug text-gray-900 mt-0.5" style={{
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif'
            }} data-id="element-12">
                  <span className="font-semibold" data-id="element-13">{buyer.name}</span>
                  <span className="text-gray-500" data-id="element-14"> de {buyer.city}</span>
                  <span className="text-gray-500" data-id="element-15"> compró </span>
                  <span className="font-semibold italic" data-id="element-16">{PRODUCT_NAME}</span>
                  <span className="font-bold text-green-600" data-id="element-17">
                    {' '}
                    {PRODUCT_PRICE}
                  </span>
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}